import React, { Component } from "react";
import { createPortal } from "react-dom";
import "./CRMSearchAnim.css";
import {
  PageHeader,
  Typography,
  notification,
  Modal,
  Tooltip,
  Spin,
  Select,
  Tag,
} from "antd";
import {
  PlusOutlined,
  FileExcelOutlined,
  SettingOutlined,
  UserAddOutlined,
  MenuOutlined,
  AppstoreOutlined,
  TrophyOutlined,
  CloseCircleOutlined,
  SearchOutlined,
  StarFilled,
  StarOutlined,
  SortAscendingOutlined,
  CalendarOutlined,
  WhatsAppOutlined,
  ShopOutlined,
  UnorderedListOutlined,
  InsertRowAboveOutlined
} from "@ant-design/icons";
import { DndContext, DragOverlay, PointerSensor } from "@dnd-kit/core";
import {
  ButtonItem,
  HeaderActions,
  InputItem,
  SelectEmbudosItem,
  SubHeaderItem,
  TableItemDinamico,
  SegmentedItem,
  dineroDisabledMask,
  RangePickerItem,
} from "../../../Components/Items";
import DroppableColumn from "./Components/DroppableColumn";
import DraggableCard from "./Components/DraggableCard";
import ModalTransicion from "./Components/ModalTransicion";
import DrawerLead from "./Components/DrawerLead";
import ModalLead from "./Components/ModalLead";
import ModalReasignarLead from "./Components/ModalReasignarLead";
import ModalMotivoPerdida from "./Components/ModalMotivoPerdida";
import ModalAsignarLeadsShopify from "./Components/ModalAsignarLeadsShopify";
import DroppableZone from "./Components/DroppableZone";
import ChatLeadWhatsapp from "./Components/ChatLeadWhatsapp";
import axios from "axios";
import { connect } from "react-redux";
import debounce from "lodash.debounce";

const { Title, Text } = Typography;

const sensorsConfig = [
  { sensor: PointerSensor, options: { activationConstraint: { distance: 8 } } },
];

const pesoUrgencia = (avisoActivo) => {
  if (!avisoActivo || avisoActivo.tipo === null) return Infinity;
  if (avisoActivo.tipo === "finalizacion") return 0;
  return avisoActivo.totalAvisos - avisoActivo.indiceAviso;
};

class CRMDashboard extends Component {
  tableRef = null;

  state = {
    leads: [],
    transiciones: [],
    embudoSeleccionado: null,

    loadingTablero: false,
    activeId: null,
    activeLead: null,
    // Modal de transicion
    modalTransicionVisible: false,
    transicionActiva: null,
    leadEnTransito: null,
    etapaDestinoTemporal: null,
    // Para el drawer
    drawerDetalleVisible: false,
    leadDetalle: null,
    // Para mostrar detalles de los leads en el dashoboard
    mostrarDetalles: false,

    //Modal del lead
    modalLeadVisible: false,
    leadAEditar: null,

    // Estado para el buscador
    searchText: "",
    fechaFiltro: null,

    // Para el embudo por defecto
    embudoPorDefectoId: null,
    guardandoFavorito: false,
    cargandoInicial: true,

    // Master CRM
    usuarioFiltroId: null,
    usuariosEmpresa: [], // lista de usuarios para el filtro master
    modalReasignarVisible: false,
    leadAReasignar: null,
    reasignarRapido: false,

    // Modal motivo pérdida
    modalMotivoPerdidaVisible: false,
    leadParaPerder: null,

    // WhatsApp
    filtroSoloNoLeidos: false,
    chatWhatsappLead: null,

    // Shopify
    sincronizandoShopify: false,
    leadsPendientesShopify: 0,
    modalAsignarShopifyVisible: false,

    // Vista tabla
    vistaTabla: false,
    leadsTabla: [],
    totalLeadsTabla: 0,
    loadingTabla: false,
    etapaFiltroTabla: "todas",
    estadoFiltroTabla: 1,
  };

  constructor(props) {
    super(props);
    this.buscarLeadsConRetraso = debounce(this.cargarLeadsDelBackend, 400);
    this.buscarEnTablaConRetraso = debounce((extFilters) => {
      if (this.tableRef) this.tableRef.updateExternalFilters(extFilters);
    }, 400);
  }

  componentDidMount() {
    this.cargarEmbudoPorDefecto();
    if (this.props.permisoMasterCRM) {
      this.cargarUsuariosEmpresa();
      this.cargarLeadsPendientesShopify();
    }
  }

  cargarUsuariosEmpresa = () => {
    axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({ usuariosEmpresa: res.data });
        }
      })
      .catch(() => {});
  };

  obtenerRangoFechaFiltro = (rango = this.state.fechaFiltro) => {
    const [inicio, fin] = rango || [];
    return {
      fechaInicio: inicio?.format("YYYY-MM-DD"),
      fechaFin: fin?.format("YYYY-MM-DD"),
    };
  };

  onChangeEmbudo = (id, embudoCompleto) => {
    this.setState(
      {
        embudoSeleccionadoId: id?.toString(),
        embudoSeleccionadoObjeto: embudoCompleto,
        leads: [],
        etapaFiltroTabla: "todas",
        estadoFiltroTabla: 1,
      },
      () => {
        if (id) {
          if (this.state.vistaTabla) {
            if (this.tableRef) {
              this.tableRef.updateExternalFilters({
                etapaId: "todas",
                estadoLead: 1,
                ...this.obtenerRangoFechaFiltro(),
              });
            }
          } else {
            this.cargarTablero(id);
          }
        }
      },
    );
  };

  onChangeUsuarioFiltro = (id) => {
    this.setState({ usuarioFiltroId: id ?? null }, () => {
      if (this.state.embudoSeleccionadoId) {
        if (this.state.vistaTabla && this.tableRef) {
          this.tableRef.updateExternalFilters({
            etapaId: this.state.etapaFiltroTabla,
            estadoLead: this.state.estadoFiltroTabla,
            ...this.obtenerRangoFechaFiltro(),
          });
        } else {
          this.cargarLeadsDelBackend();
        }
      }
    });
  };

  handleFechaFiltroChange = (rango) => {
    this.setState({ fechaFiltro: rango }, () => {
      if (!this.state.embudoSeleccionadoId) return;
      if (this.state.vistaTabla && this.tableRef) {
        this.tableRef.updateExternalFilters({
          etapaId: this.state.etapaFiltroTabla,
          estadoLead: this.state.estadoFiltroTabla,
          ...this.obtenerRangoFechaFiltro(rango),
        });
      } else {
        this.cargarLeadsDelBackend();
      }
    });
  };

  abrirModalReasignar = (lead, rapido = false) => {
    this.setState({
      modalReasignarVisible: true,
      leadAReasignar: lead,
      reasignarRapido: rapido,
    });
  };

  abrirAsignarDesdeTablero = (lead) => {
    this.abrirModalReasignar(lead, true);
  };

  cerrarModalReasignar = () => {
    this.setState({ modalReasignarVisible: false, leadAReasignar: null });
  };

  onReasignarExito = () => {
    this.cargarLeadsDelBackend();
    this.cerrarModalReasignar();
  };

  cargarTablero = async (embudoId) => {
    this.setState({ loadingTablero: true });
    try {
      const [resTransiciones, resLeads] = await Promise.all([
        axios.post(
          "embudos/transicionesEmbudo",
          { embudoId },
          { headers: this.props.headersToken },
        ),
        axios.post(
          "leads/selectLeadsDashboard",
          {
            embudoId,
            textoBuscar: this.state.searchText,
            empresaId: this.props.empresaId,
            usuarioFiltroId: this.props.permisoMasterCRM
              ? (this.state.usuarioFiltroId ?? "todos")
              : undefined,
            ...this.obtenerRangoFechaFiltro(),
          },
          { headers: this.props.headersToken },
        ),
      ]);

      if (resTransiciones.data.success === 2 && resLeads.data.success === 2) {
        this.setState({
          transiciones: resTransiciones.data.transiciones,
          leads: resLeads.data.leads,
        });
      } else {
        notification.error({
          message: "Error al cargar la configuración del embudo.",
        });
      }
    } catch (error) {
      console.error(error);
      notification.error({ message: "Error de red al cargar el tablero." });
    } finally {
      this.setState({ loadingTablero: false });
    }
  };

  cargarLeadsDelBackend = () => {
    const { embudoSeleccionadoId, searchText, usuarioFiltroId, fechaFiltro } =
      this.state;
    if (!embudoSeleccionadoId) return;

    this.setState({ loadingTablero: true });
    axios
      .post(
        "leads/selectLeadsDashboard",
        {
          embudoId: embudoSeleccionadoId,
          textoBuscar: searchText,
          empresaId: this.props.empresaId,
          usuarioFiltroId: this.props.permisoMasterCRM
            ? (usuarioFiltroId ?? "todos")
            : undefined,
          ...this.obtenerRangoFechaFiltro(fechaFiltro),
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ leads: res.data.leads });
        }
      })
      .finally(() => this.setState({ loadingTablero: false }));
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value }, () => {
      if (this.state.vistaTabla) {
        this.buscarEnTablaConRetraso({
          etapaId: this.state.etapaFiltroTabla,
          estadoLead: this.state.estadoFiltroTabla,
          textoBuscar: this.state.searchText,
        });
      } else {
        this.buscarLeadsConRetraso();
      }
    });
  };

  consultarLeadsTabla = (params) => {
    const { embudoSeleccionadoId, usuarioFiltroId } = this.state;
    if (!embudoSeleccionadoId) return;

    this.setState({ loadingTabla: true });
    axios
      .post(
        "leads/selectLeadsTabla",
        {
          embudoId: embudoSeleccionadoId,
          empresaId: this.props.empresaId,
          usuarioFiltroId: this.props.permisoMasterCRM
            ? (usuarioFiltroId ?? "todos")
            : undefined,
          ...params,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            leadsTabla: res.data.leads,
            totalLeadsTabla: res.data.totalRecords || 0,
          });
        } else {
          this.setState({ leadsTabla: [] });
        }
      })
      .catch(() => notification.error({ message: "Error al cargar leads." }))
      .finally(() => this.setState({ loadingTabla: false }));
  };

  toggleVistaTabla = () => {
    const {
      vistaTabla,
      embudoSeleccionadoId,
      etapaFiltroTabla,
      estadoFiltroTabla,
    } = this.state;
    if (!vistaTabla) {
      this.setState({ vistaTabla: true }, () => {
        if (embudoSeleccionadoId && this.tableRef) {
          this.tableRef.updateExternalFilters({
            etapaId: etapaFiltroTabla,
            estadoLead: estadoFiltroTabla,
            ...this.obtenerRangoFechaFiltro(),
          });
        }
      });
    } else {
      this.setState({ vistaTabla: false }, () => this.cargarLeadsDelBackend());
    }
  };

  onLeadGuardadoExito = () => {
    this.cargarLeadsDelBackend();
    this.cerrarLead();
  };

  handleDragStart = (event) => {
    const { active } = event;
    const lead = active.data.current?.lead;
    this.setState({ activeId: active.id, activeLead: lead });
  };

  handleDragEnd = (event) => {
    const { active, over } = event;
    this.setState({ activeId: null, activeLead: null });

    if (!over) return;

    const destinoId = over.id;
    const lead = active.data.current?.lead;
    if (lead.estado === 0) return;

    if (destinoId === "zona_ganado") {
      Modal.confirm({
        title: "¿Confirmar Cierre Ganado?",
        content: `¿Estás seguro de marcar "${lead.descripcion}" como ganado y cerrarlo? Ya no aparecerá en el tablero principal.`,
        okText: "Sí, Cerrar",
        okType: "primary",
        cancelText: "Cancelar",
        onOk: () => {
          this.cambiarEstadoLead(lead._id, 3);
        },
      });
      return;
    }

    if (destinoId === "zona_perdido") {
      this.setState({ modalMotivoPerdidaVisible: true, leadParaPerder: lead });
      return;
    }

    if (lead.etapaActualId === destinoId) return;

    const transicionRequerida = this.state.transiciones.find(
      (t) =>
        t.estadoEmbudoOrigen === lead.etapaActualId &&
        t.estadoEmbudoDestino === destinoId,
    );

    if (!transicionRequerida) {
      notification.warning({
        message: "Movimiento no permitido",
        description: "No hay una transición configurada para este movimiento.",
      });
      return;
    }

    const requiereModal =
      (transicionRequerida.campos && transicionRequerida.campos.length > 0) ||
      (transicionRequerida.documentoRequerido &&
        transicionRequerida.documentoRequerido !== "Ninguno");

    if (requiereModal) {
      const nuevaEtapa = this.state.embudoSeleccionadoObjeto?.etapas.find(
        (e) => e._id.toString() === destinoId.toString(),
      );
      this.setState({
        modalTransicionVisible: true,
        transicionActiva: transicionRequerida,
        leadEnTransito: lead,
        etapaDestinoTemporal: destinoId,
        estadoNuevoTemporal: nuevaEtapa?.considerarGanado ? 2 : 1,
      });
    } else {
      axios
        .post(
          "leads/ejecutarTransicion",
          {
            leadId: lead._id,
            transicionId: transicionRequerida._id,
            campos: {},
            documentoId: null,
          },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.success === 2) {
            const nuevaEtapa = this.state.embudoSeleccionadoObjeto?.etapas.find(
              (e) => e._id.toString() === destinoId.toString(),
            );
            notification.success({
              message: `Movido a ${nuevaEtapa?.nombre || "nueva etapa"}`,
            });
            this.cargarLeadsDelBackend();
          } else {
            notification.error({ message: res.data.message });
          }
        })
        .catch(() =>
          notification.error({ message: "Error al mover el lead." }),
        );
    }
  };

  onConfirmarPerdida = (motivo) => {
    const { leadParaPerder } = this.state;
    this.cambiarEstadoLead(leadParaPerder._id, 0, motivo);
    this.setState({ modalMotivoPerdidaVisible: false, leadParaPerder: null });
  };

  cambiarEstadoLead = async (leadId, nuevoEstado, motivoPerdida = null) => {
    try {
      const res = await axios.post(
        "leads/cambiarEstado",
        {
          leadId,
          estado: nuevoEstado,
          ...(nuevoEstado === 0 && motivoPerdida ? { motivoPerdida } : {}),
        },
        { headers: this.props.headersToken },
      );

      if (res.data.success === 2) {
        this.cargarLeadsDelBackend();
        if (nuevoEstado === 3)
          notification.success({ message: "¡Lead Ganado!" });
        if (nuevoEstado === 0) notification.info({ message: "Lead Archivado" });
      }
    } catch {
      notification.error({ message: "Error al actualizar el lead." });
    }
  };

  abrirLead = (lead) => {
    this.setState({ drawerDetalleVisible: true, leadDetalle: lead });
  };

  cerrarLead = () => {
    this.setState({ drawerDetalleVisible: false, leadDetalle: null });
  };

  toggleTarea = (leadId, tareaIndex) => {
    this.setState((prevState) => {
      const leadsActualizados = prevState.leads.map((lead) => {
        if (lead._id === leadId) {
          const tareasActualizadas = [...lead.tareas];
          tareasActualizadas[tareaIndex].completado =
            !tareasActualizadas[tareaIndex].completado;

          const leadModificado = { ...lead, tareas: tareasActualizadas };
          if (prevState.leadDetalle?._id === leadId) {
            this.setState({ leadDetalle: leadModificado });
          }
          return leadModificado;
        }
        return lead;
      });
      return { leads: leadsActualizados };
    });
  };

  actualizarComentarioTarea = (leadId, tareaIndex, comentario) => {
    this.setState((prevState) => {
      const leadsActualizados = prevState.leads.map((lead) => {
        if (lead._id === leadId) {
          const tareasActualizadas = [...lead.tareas];
          tareasActualizadas[tareaIndex].comentario = comentario; // Guardamos el comentario

          const leadModificado = { ...lead, tareas: tareasActualizadas };
          if (prevState.leadDetalle?._id === leadId) {
            this.setState({ leadDetalle: leadModificado });
          }
          return leadModificado;
        }
        return lead;
      });
      return { leads: leadsActualizados };
    });
  };

  agregarNuevaTarea = (leadId, descripcion) => {
    const nuevaTarea = { descripcion, completado: false, comentario: "" };

    this.setState((prevState) => {
      const leadsActualizados = prevState.leads.map((lead) => {
        if (lead._id === leadId) {
          const tareasActualizadas = [...(lead.tareas || []), nuevaTarea];
          const leadModificado = { ...lead, tareas: tareasActualizadas };
          if (prevState.leadDetalle?._id === leadId) {
            this.setState({ leadDetalle: leadModificado });
          }
          return leadModificado;
        }
        return lead;
      });
      return { leads: leadsActualizados };
    });
    notification.success({ message: "Tarea añadida correctamente" });
  };

  leadPasaFiltros = (lead) => {
    if (this.state.filtroSoloNoLeidos && (lead.whatsappNoLeidos ?? 0) <= 0) {
      return false;
    }
    const searchLower = this.state.searchText.toLowerCase();
    return (
      lead.descripcion.toLowerCase().includes(searchLower) ||
      (lead.contactoId?.nombre + " " + lead.contactoId?.apellidoPaterno)
        .toLowerCase()
        .includes(searchLower)
    );
  };

  getCardsForColumn = (etapa) => {
    const { leads, ordenarPorUrgencia } = this.state;

    let leadsFiltrados = leads.filter(
      (l) => l.etapaActualId === etapa._id && this.leadPasaFiltros(l),
    );

    if (ordenarPorUrgencia) {
      leadsFiltrados = [...leadsFiltrados].sort(
        (a, b) => pesoUrgencia(a.avisoActivo) - pesoUrgencia(b.avisoActivo),
      );
    }

    return leadsFiltrados.length > 0 ? (
      leadsFiltrados.map((lead) => (
        <DraggableCard
          key={lead._id}
          id={lead._id}
          lead={lead}
          colorEtapa={etapa.color}
          probabilidad={etapa.probabilidadExito}
          onVerDetalle={this.abrirLead}
          mostrarDetalles={this.state.mostrarDetalles}
          avisoActivo={lead.avisoActivo ?? null}
          onAbrirWhatsapp={
            this.props.tieneWhatsapp ? this.abrirChatWhatsapp : undefined
          }
          esMaster={!!this.props.permisoMasterCRM}
          onAsignar={
            this.props.permisoMasterCRM ? this.abrirAsignarDesdeTablero : undefined
          }
        />
      ))
    ) : (
      <div style={{ textAlign: "center", marginTop: 20, opacity: 0.3 }}>
        <Text style={{ fontSize: 10 }}>Vacío</Text>
      </div>
    );
  };

  toggleOrdenUrgencia = () => {
    this.setState((prevState) => ({
      ordenarPorUrgencia: !prevState.ordenarPorUrgencia,
    }));
  };

  calcularTotalColumna = (etapaId) => {
    return this.state.leads
      .filter((l) => l.etapaActualId === etapaId && this.leadPasaFiltros(l))
      .reduce((sum, lead) => sum + (lead.valorPonderado ?? 0), 0);
  };

  contarLeadsColumna = (etapaId) =>
    this.state.leads.filter(
      (l) => l.etapaActualId === etapaId && this.leadPasaFiltros(l),
    ).length;

  // Suma de mensajes sin leer de los leads visibles en la etapa.
  totalNoLeidosColumna = (etapaId) =>
    this.state.leads
      .filter((l) => l.etapaActualId === etapaId && this.leadPasaFiltros(l))
      .reduce((sum, lead) => sum + (lead.whatsappNoLeidos ?? 0), 0);

  abrirChatWhatsapp = (lead) => {
    this.setState({ chatWhatsappLead: lead });
  };

  cerrarChatWhatsapp = () => {
    this.setState({ chatWhatsappLead: null });
  };

  toggleFiltroNoLeidos = () => {
    this.setState((prev) => ({ filtroSoloNoLeidos: !prev.filtroSoloNoLeidos }));
  };

  toggleVista = () => {
    this.setState((prevState) => ({
      mostrarDetalles: !prevState.mostrarDetalles,
    }));
  };

  abrirModalNuevoLead = () => {
    this.setState({ modalLeadVisible: true, leadAEditar: null });
  };

  abrirModalEditarLead = (lead) => {
    this.setState({ modalLeadVisible: true, leadAEditar: lead._id });
  };

  cerrarModalLead = () => {
    this.setState({ modalLeadVisible: false, leadAEditar: null });
  };

  guardarLead = (valoresFormulario, leadId) => {
    const contactoEncontrado = this.state.contactos.find(
      (c) => c._id === valoresFormulario.contactoId,
    );

    this.setState((prevState) => {
      let leadsActualizados;

      if (leadId) {
        leadsActualizados = prevState.leads.map((lead) =>
          lead._id === leadId
            ? { ...lead, ...valoresFormulario, contacto: contactoEncontrado }
            : lead,
        );
        notification.success({ message: "Lead actualizado correctamente" });
      } else {
        const nuevoLead = {
          _id: `lead_nuevo_${Date.now()}`,
          ...valoresFormulario,
          contacto: contactoEncontrado,
          tareas: [],
        };
        leadsActualizados = [...prevState.leads, nuevoLead];
        notification.success({ message: "Lead creado correctamente" });
      }

      return {
        leads: leadsActualizados,
        modalLeadVisible: false,
        leadAEditar: null,
      };
    });
  };

  guardarTarea = ({
    leadId,
    tareaId = null,
    titulo,
    descripcion = "",
    comentario = "",
    fechaInicio = null,
    fechaFin = null,
    todoElDia = false,
  }) => {
    axios
      .post(
        "leads/guardarTarea",
        {
          leadId,
          tareaId,
          titulo,
          descripcion,
          comentario,
          fechaInicio,
          fechaFin,
          todoElDia,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.actualizarTareasEnEstado(leadId, res.data.tareas);
          notification.success({
            message: tareaId
              ? "Tarea actualizada."
              : "Tarea añadida correctamente",
          });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() =>
        notification.error({ message: "Error al guardar la tarea." }),
      );
  };

  toggleTarea = (leadId, tareaId) => {
    axios
      .post(
        "leads/toggleTarea",
        { leadId, tareaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.actualizarTareasEnEstado(leadId, res.data.tareas);
        }
      })
      .catch(() =>
        notification.error({ message: "Error al actualizar la tarea." }),
      );
  };

  actualizarComentarioTarea = (
    leadId,
    tareaId,
    comentario,
    tareasDirectas = null,
  ) => {
    if (tareasDirectas) {
      this.actualizarTareasEnEstado(leadId, tareasDirectas);
      return;
    }

    axios
      .post(
        "leads/actualizarComentarioTarea",
        { leadId, tareaId, comentario },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.actualizarTareasEnEstado(leadId, res.data.tareas);
        }
      })
      .catch(() =>
        notification.error({ message: "Error al guardar el comentario." }),
      );
  };
  actualizarTareasEnEstado = (leadId, tareas) => {
    this.setState((prevState) => {
      const leads = prevState.leads.map((l) =>
        l._id.toString() === leadId.toString() ? { ...l, tareas } : l,
      );
      const leadDetalle =
        prevState.leadDetalle?._id.toString() === leadId.toString()
          ? { ...prevState.leadDetalle, tareas }
          : prevState.leadDetalle;

      return { leads, leadDetalle };
    });
  };

  cargarEmbudoPorDefecto = async () => {
    axios
      .post(
        "embudos/obtenerEmbudoPorDefecto",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.embudoPorDefecto) {
          const id = res.data.embudoPorDefecto.toString();

          this.setState({
            embudoSeleccionadoId: id,
            embudoPorDefectoId: id,
          });
        }
      })
      .catch((error) => {
        console.error("Error al cargar embudo por defecto:", error);
      })
      .finally(() => {
        this.setState({ cargandoInicial: false });
      });
  };

  sincronizarShopify = () => {
    this.setState({ sincronizandoShopify: true });
    axios
      .post(
        "shopify/sincronizarShopify",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          this.cargarLeadsDelBackend();
          this.cargarLeadsPendientesShopify();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() =>
        notification.error({ message: "Error al sincronizar con Shopify." }),
      )
      .finally(() => this.setState({ sincronizandoShopify: false }));
  };

  cargarLeadsPendientesShopify = () => {
    axios
      .post(
        "shopify/leadsShopifyPendientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ leadsPendientesShopify: res.data.total });
        }
      })
      .catch(() => {});
  };

  guardarEmbudoFavorito = async () => {
    const { embudoSeleccionadoId } = this.state;
    if (!embudoSeleccionadoId) return;

    this.setState({ guardandoFavorito: true });
    axios
      .post(
        "embudos/guardarEmbudoPorDefecto",
        { embudoId: embudoSeleccionadoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            embudoPorDefectoId: embudoSeleccionadoId.toString(),
          });
          notification.success({ message: "Embudo guardado como favorito." });
        }
      })
      .catch(() => {
        notification.error({ message: "Error al guardar el favorito." });
      })
      .finally(() => {
        this.setState({ guardandoFavorito: false });
      });
  };

  renderLoadingOverlay = (loading) => {
    if (!loading) return null;
    return (
      <div className="crm-loading-overlay">
        <div className="crm-loading-spinner" />
        <span className="crm-loading-text">Actualizando leads...</span>
      </div>
    );
  };

  render() {
    const {
      embudoSeleccionadoId,
      embudoPorDefectoId,
      embudoSeleccionadoObjeto,
      activeId,
      activeLead,
      transicionActiva,
      modalTransicionVisible,
      loadingTablero,
      guardandoFavorito,
      ordenarPorUrgencia,
      filtroSoloNoLeidos,
      chatWhatsappLead,
    } = this.state;

    const etapasOrdenadas = embudoSeleccionadoObjeto
      ? [...embudoSeleccionadoObjeto.etapas].sort((a, b) => a.orden - b.orden)
      : [];

    const totalEtapas = etapasOrdenadas.length;
    // Siempre habilitar scroll horizontal — en pantallas pequeñas puede ser necesario
    // incluso con pocas etapas. Se calculan 280px por etapa como ancho mínimo.
    const anchoMinimo = totalEtapas * 280;

    const etapaDelLeadActivo =
      activeLead && embudoSeleccionadoObjeto
        ? embudoSeleccionadoObjeto.etapas.find(
            (e) => e._id === activeLead.etapaActualId,
          )
        : null;

    const etapaDrawer =
      this.state.leadDetalle && embudoSeleccionadoObjeto
        ? embudoSeleccionadoObjeto.etapas.find(
            (e) => e._id === this.state.leadDetalle.etapaActualId,
          )
        : null;

    const esFavorito =
      embudoSeleccionadoId &&
      embudoPorDefectoId &&
      embudoSeleccionadoId.toString() === embudoPorDefectoId.toString();

    const etapaMap = {};
    etapasOrdenadas.forEach((e) => {
      etapaMap[e._id] = e;
    });

    const columnsTabla = [
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        buscar: "descripcion",
        sorter: true,
        ellipsis: true,
        width: "18%",
      },
      {
        title: "Contacto",
        dataIndex: "contactoId",
        key: "contacto",
        buscar: "contacto",
        ellipsis: true,
        width: "14%",
        render: (contacto) =>
          contacto
            ? `${contacto.nombre ?? ""} ${contacto.apellidoPaterno ?? ""} ${contacto.apellidoMaterno ?? ""}`.trim()
            : "-",
      },
      {
        title: "Teléfono",
        dataIndex: "numero",
        key: "numero",
        width: "10%",
        render: (val, record) => val || record.contactoId?.numero || "-",
      },
      {
        title: "Etapa",
        dataIndex: "etapaActualId",
        key: "etapa",
        width: "10%",
        render: (etapaId) => {
          const etapa = etapaMap[etapaId];
          return etapa ? <Tag color={etapa.color}>{etapa.nombre}</Tag> : "-";
        },
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        align: "center",
        render: (val) => {
          if (val === 1) return <Tag color="blue">Activo</Tag>;
          if (val === 3) return <Tag color="green">Ganado</Tag>;
          if (val === 0) return <Tag color="red">Perdido</Tag>;
          return "-";
        },
      },
      {
        title: "Valor / Val. Pond.",
        dataIndex: "valor",
        key: "valor",
        sorter: true,
        align: "right",
        width: "12%",
        render: (val, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", fontWeight: "bold" }}>
              {dineroDisabledMask(record.valor ?? 0)}
            </div>
            <div style={{ fontSize: "11px", color: "#999" }}>
              {dineroDisabledMask(record.valorPonderado ?? 0)}
            </div>
          </div>
        ),
      },
      ...(this.props.permisoMasterCRM
        ? [
            {
              title: "Vendedor",
              dataIndex: "usuarioId",
              key: "usuarioId",
              width: "10%",
              ellipsis: true,
              render: (u) =>
                u ? `${u.nombre ?? ""} ${u.apellidoPaterno ?? ""}`.trim() : "-",
            },
          ]
        : []),
      {
        title: "Tareas",
        dataIndex: "tareas",
        key: "tareas",
        width: "6%",
        align: "center",
        render: (tareas) => {
          const pendientes = (tareas || []).filter((t) => !t.completado).length;
          return pendientes > 0 ? (
            <Tag color="orange">{pendientes}</Tag>
          ) : (
            <span style={{ color: "#bbb" }}>-</span>
          );
        },
      },
      ...(this.props.tieneWhatsapp
        ? [
            {
              title: "WhatsApp",
              dataIndex: "whatsappNoLeidos",
              key: "whatsapp",
              width: "7%",
              align: "center",
              render: (count) =>
                count > 0 ? (
                  <Tag color="#25D366" style={{ color: "#fff" }}>
                    {count}
                  </Tag>
                ) : (
                  <span style={{ color: "#bbb" }}>-</span>
                ),
            },
          ]
        : []),
      {
        title: "Acciones",
        key: "acciones",
        width: "14%",
        align: "center",
        render: (_, record) => (
          <div
            style={{
              display: "flex",
              gap: 4,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Tooltip title="Ver detalle">
              <ButtonItem
                azul
                size="small"
                icon={<SearchOutlined />}
                onClick={() => this.abrirLead(record)}
              />
            </Tooltip>
            <Tooltip title="Editar">
              <ButtonItem
                naranja
                size="small"
                icon={<SettingOutlined />}
                onClick={() => this.abrirModalEditarLead(record)}
              />
            </Tooltip>
            {this.props.permisoMasterCRM && (
              <Tooltip title="Reasignar">
                <ButtonItem
                  morado
                  size="small"
                  icon={<UserAddOutlined />}
                  onClick={() => this.abrirModalReasignar(record)}
                />
              </Tooltip>
            )}
            {this.props.tieneWhatsapp && (
              <Tooltip title="Abrir chat">
                <ButtonItem
                  verde
                  size="small"
                  icon={<WhatsAppOutlined />}
                  onClick={() => this.abrirChatWhatsapp(record)}
                />
              </Tooltip>
            )}
          </div>
        ),
      },
    ];

    return (
      <>
        {/* Modales */}
        <DrawerLead
          visible={this.state.drawerDetalleVisible}
          lead={this.state.leadDetalle}
          onClose={this.cerrarLead}
          onToggleTarea={this.toggleTarea}
          onAddTarea={this.guardarTarea}
          onUpdateComentario={this.actualizarComentarioTarea}
          onEditarLead={this.abrirModalEditarLead}
          colorEtapa={etapaDrawer?.color}
          esMaster={!!this.props.permisoMasterCRM}
          onReasignar={this.abrirModalReasignar}
          tieneWhatsapp={this.props.tieneWhatsapp}
          onAbrirChatModal={
            this.props.tieneWhatsapp ? this.abrirChatWhatsapp : undefined
          }
        />

        <Modal
          title={
            <span>
              <WhatsAppOutlined style={{ color: "#25D366", marginRight: 8 }} />
              {chatWhatsappLead?.descripcion ||
                `${chatWhatsappLead?.contactoId?.nombre ?? ""} ${
                  chatWhatsappLead?.contactoId?.apellidoPaterno ?? ""
                }`.trim() ||
                "WhatsApp"}
            </span>
          }
          visible={!!chatWhatsappLead}
          onCancel={this.cerrarChatWhatsapp}
          footer={null}
          destroyOnClose
          width="90vw"
          style={{ top: 24, maxWidth: 1100 }}
          bodyStyle={{ padding: 12 }}
        >
          {chatWhatsappLead && (
            <ChatLeadWhatsapp
              telefono={
                chatWhatsappLead.numero || chatWhatsappLead.contactoId?.numero
              }
              leadId={chatWhatsappLead._id}
              height="80vh"
            />
          )}
        </Modal>

        <ModalReasignarLead
          visible={this.state.modalReasignarVisible}
          lead={this.state.leadAReasignar}
          rapido={this.state.reasignarRapido}
          onCancel={this.cerrarModalReasignar}
          onExito={this.onReasignarExito}
        />

        <ModalMotivoPerdida
          visible={this.state.modalMotivoPerdidaVisible}
          lead={this.state.leadParaPerder}
          onCancel={() =>
            this.setState({
              modalMotivoPerdidaVisible: false,
              leadParaPerder: null,
            })
          }
          onConfirmar={this.onConfirmarPerdida}
        />

        <ModalAsignarLeadsShopify
          visible={this.state.modalAsignarShopifyVisible}
          onCancel={() => this.setState({ modalAsignarShopifyVisible: false })}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          onLeadAsignado={this.cargarLeadsPendientesShopify}
        />

        {/* Modales */}

        <ModalTransicion
          visible={modalTransicionVisible}
          transicionActiva={transicionActiva}
          leadId={this.state.leadEnTransito?._id}
          onCancel={() =>
            this.setState({
              modalTransicionVisible: false,
              transicionActiva: null,
              leadEnTransito: null,
            })
          }
          onExito={() => this.cargarLeadsDelBackend()}
        />

        <ModalLead
          visible={this.state.modalLeadVisible}
          onCancel={this.cerrarModalLead}
          onSuccess={this.onLeadGuardadoExito}
          leadAEditar={this.state.leadAEditar}
          embudoSeleccionado={embudoSeleccionadoId}
          embudoSeleccionadoObjeto={embudoSeleccionadoObjeto}
          contactosMock={this.state.contactos}
          esMaster={!!this.props.permisoMasterCRM}
        />

        {/* Contexto para el drag y drop */}

        <DndContext
          onDragStart={this.handleDragStart}
          sensors={sensorsConfig}
          onDragEnd={this.handleDragEnd}
        >
          <PageHeader
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Tooltip title="Ir al calendario">
                  <CalendarOutlined
                    onClick={() =>
                      this.props.history.push("/panel/crmCalendario")
                    }
                    style={{ fontSize: 16, color: "#bbb", cursor: "pointer" }}
                  />
                </Tooltip>
                Mi tablero
              </div>
            }
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 0,
              borderRadius: "6px 6px 0 0",
            }}
            extra={
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                {this.state.cargandoInicial ? (
                  <Spin
                    size="small"
                    style={{
                      width: 220,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  />
                ) : (
                  <SelectEmbudosItem
                    headersToken={this.props.headersToken}
                    placeholder="Selecciona un Embudo"
                    style={{ width: 220 }}
                    onChange={this.onChangeEmbudo}
                    autoseleccionar={!this.state.embudoPorDefectoId}
                    value={this.state.embudoSeleccionadoId}
                    empresaId={this.props.empresaId}
                  />
                )}

                <Tooltip
                  title={
                    esFavorito
                      ? "Embudo favorito actual"
                      : "Guardar como favorito"
                  }
                >
                  <ButtonItem
                    ambar={esFavorito}
                    blanco={!esFavorito}
                    className="botonAgregar"
                    icon={
                      guardandoFavorito ? (
                        <Spin size="small" />
                      ) : esFavorito ? (
                        <StarFilled />
                      ) : (
                        <StarOutlined />
                      )
                    }
                    onClick={this.guardarEmbudoFavorito}
                    disabled={!embudoSeleccionadoId || guardandoFavorito}
                  />
                </Tooltip>

                <ButtonItem
                  className="botonAgregar"
                  azul
                  icon={<PlusOutlined />}
                  onClick={this.abrirModalNuevoLead}
                >
                  Lead
                </ButtonItem>

                <Tooltip
                  title={this.state.vistaTabla ? "Vista Tablero" : "Vista Tabla"}
                >
                  <ButtonItem
                    className="botonAgregar"
                    blanco
                    icon={
                      this.state.vistaTabla ? (
                        <InsertRowAboveOutlined />
                      ) : (
                        <UnorderedListOutlined />
                      )
                    }
                    onClick={this.toggleVistaTabla}
                    disabled={!embudoSeleccionadoId}
                  />
                </Tooltip>

                <HeaderActions>
                  <ButtonItem
                    className="botonAgregar"
                    turquesa
                    icon={<UserAddOutlined />}
                    onClick={() =>
                      this.props.history.push("/panel/crmContactos")
                    }
                  >
                    Contacto
                  </ButtonItem>
                  <ButtonItem
                    className="botonAgregar"
                    verde
                    disabled
                    icon={<FileExcelOutlined />}
                  >
                    Importar
                  </ButtonItem>
                  {this.props.permisoMasterCRM && (
                    <>
                      {this.state.leadsPendientesShopify > 0 && (
                        <ButtonItem
                          className="botonAgregar"
                          naranja
                          icon={<UnorderedListOutlined />}
                          onClick={() =>
                            this.setState({ modalAsignarShopifyVisible: true })
                          }
                        >
                          Leads Shopify Sin Asignar (
                          {this.state.leadsPendientesShopify})
                        </ButtonItem>
                      )}
                      <ButtonItem
                        className="botonAgregar"
                        verde
                        icon={<ShopOutlined />}
                        onClick={this.sincronizarShopify}
                        loading={this.state.sincronizandoShopify}
                      >
                        Importar desde Shopify
                      </ButtonItem>
                    </>
                  )}
                  {this.props.permisoAccesoConfiguracionCRM ? (
                    <ButtonItem
                      className="botonAgregar"
                      blanco
                      icon={<SettingOutlined />}
                      onClick={() =>
                        this.props.history.push("/panel/crmConfiguracion")
                      }
                    >
                      Configuración
                    </ButtonItem>
                  ) : null}
                </HeaderActions>
              </div>
            }
          />

          <SubHeaderItem>
            <InputItem
              placeholder="Buscar lead o contacto..."
              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
              style={{ width: 220, borderRadius: "4px" }}
              allowClear
              onChange={this.handleSearchChange}
            />

            <RangePickerItem
              placeholder={["Fecha inicio", "Fecha fin"]}
              allowClear
              value={this.state.fechaFiltro}
              onChange={this.handleFechaFiltroChange}
              disabled={!embudoSeleccionadoId}
              style={{ width: 240 }}
            />

            {this.props.permisoMasterCRM && (
              <Select
                placeholder="Ver leads de..."
                style={{ width: 180 }}
                allowClear
                showSearch
                filterOption={(input, opt) =>
                  opt.children.toLowerCase().includes(input.toLowerCase())
                }
                value={this.state.usuarioFiltroId ?? undefined}
                onChange={(val) => this.onChangeUsuarioFiltro(val)}
              >
                {this.state.usuariosEmpresa.map((u) => (
                  <Select.Option key={u._id} value={u._id}>
                    {`${u.nombre} ${u.apellidoPaterno ?? ""}`.trim()}
                  </Select.Option>
                ))}
              </Select>
            )}

            {!this.state.vistaTabla && (
              <>
                <Tooltip
                  title={
                    ordenarPorUrgencia
                      ? "Orden por urgencia activo"
                      : "Ordenar por urgencia"
                  }
                >
                  <ButtonItem
                    className="botonAgregar"
                    blanco={!ordenarPorUrgencia}
                    azul={ordenarPorUrgencia}
                    icon={<SortAscendingOutlined />}
                    onClick={this.toggleOrdenUrgencia}
                    disabled={!embudoSeleccionadoId}
                  />
                </Tooltip>

                {this.props.tieneWhatsapp && (
                  <Tooltip
                    title={
                      filtroSoloNoLeidos
                        ? "Mostrando solo leads con mensajes sin leer"
                        : "Solo leads con mensajes sin leer"
                    }
                  >
                    <ButtonItem
                      className="botonAgregar"
                      blanco={!filtroSoloNoLeidos}
                      verde={filtroSoloNoLeidos}
                      icon={<WhatsAppOutlined />}
                      onClick={this.toggleFiltroNoLeidos}
                      disabled={!embudoSeleccionadoId}
                    />
                  </Tooltip>
                )}

                <Tooltip
                  title={
                    this.state.mostrarDetalles
                      ? "Vista Simple"
                      : "Vista Detallada"
                  }
                >
                  <ButtonItem
                    className="botonAgregar"
                    blanco
                    icon={
                      this.state.mostrarDetalles ? (
                        <MenuOutlined />
                      ) : (
                        <AppstoreOutlined />
                      )
                    }
                    onClick={this.toggleVista}
                  />
                </Tooltip>
              </>
            )}

            {/* Controles exclusivos del modo Tabla */}
            {this.state.vistaTabla && embudoSeleccionadoObjeto && (
              <>
                <SegmentedItem
                  options={[
                    { label: "Activos", value: 1 },
                    { label: "Ganados", value: 3 },
                    { label: "Perdidos", value: 0 },
                    { label: "Todos", value: "todos" },
                  ]}
                  value={this.state.estadoFiltroTabla}
                  onChange={(value) => {
                    this.setState({ estadoFiltroTabla: value });
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({
                        etapaId: this.state.etapaFiltroTabla,
                        estadoLead: value,
                        ...this.obtenerRangoFechaFiltro(),
                      });
                    }
                  }}
                />
                <SegmentedItem
                  options={[
                    { label: "Todas", value: "todas" },
                    ...etapasOrdenadas.map((e) => ({
                      label: e.nombre,
                      value: e._id,
                    })),
                  ]}
                  value={this.state.etapaFiltroTabla}
                  onChange={(value) => {
                    this.setState({ etapaFiltroTabla: value });
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({
                        etapaId: value,
                        estadoLead: this.state.estadoFiltroTabla,
                        ...this.obtenerRangoFechaFiltro(),
                      });
                    }
                  }}
                />
              </>
            )}
          </SubHeaderItem>

          {/* Kanban */}
          {!this.state.vistaTabla && (
            <div style={{ position: "relative" }}>
              {this.renderLoadingOverlay(loadingTablero)}
              {/* Contenedor principal */}
              <div style={{ marginBottom: "15px" }}>
                {/* Contenedor con el scroll */}
                <div
                  style={{
                    width: "100%",
                    overflowX: "auto",
                    paddingBottom: "10px",
                    WebkitOverflowScrolling: "touch",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      minWidth: `${anchoMinimo}px`,
                      width: "100%",
                      gap: 8,
                    }}
                  >
                    {etapasOrdenadas.length === 0 &&
                      !this.state.loadingTablero && (
                        <div
                          style={{
                            padding: 40,
                            width: "100%",
                            textAlign: "center",
                            color: "#bfbfbf",
                          }}
                        >
                          Selecciona un embudo para ver el dashboard.
                        </div>
                      )}
                    {etapasOrdenadas.map((etapa) => {
                      const totalCaja = this.calcularTotalColumna(etapa._id);
                      return (
                        <div
                          key={etapa._id}
                          style={{
                            flex: "1 1 0",
                            minWidth: "260px",
                            maxWidth: totalEtapas <= 4 ? undefined : "320px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#ffffff",
                              borderRadius: "6px",
                              padding: "12px 15px",
                              border: "1px solid #f0f0f0",
                              borderTop: `4px solid ${etapa.color}`,
                              borderTopWidth: "4px",
                              marginBottom: "5px",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.02)",
                            }}
                          >
                            <Text
                              style={{
                                display: "block",
                                fontSize: "10px",
                                color: "#bfbfbf",
                                fontWeight: "normal",
                              }}
                            >
                              Probabilidad: {etapa.probabilidadExito ?? 0}%
                            </Text>
                            <Title
                              level={5}
                              style={{
                                margin: 0,
                                textTransform: "uppercase",
                                fontSize: "13px",
                                color: "#5e6c84",
                                fontWeight: "bold",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span>{etapa.nombre}</span>

                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                {this.props.tieneWhatsapp &&
                                  this.totalNoLeidosColumna(etapa._id) > 0 && (
                                    <span
                                      title="Mensajes de WhatsApp sin leer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 3,
                                        backgroundColor: "#25D366",
                                        color: "#ffffff",
                                        padding: "2px 8px",
                                        borderRadius: "12px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <WhatsAppOutlined
                                        style={{ fontSize: 12 }}
                                      />
                                      {this.totalNoLeidosColumna(etapa._id)}
                                    </span>
                                  )}
                                <span
                                  style={{
                                    backgroundColor: "#f4f5f7",
                                    padding: "2px 8px",
                                    borderRadius: "12px",
                                    fontSize: "11px",
                                    color: "#172b4d",
                                  }}
                                >
                                  {this.contarLeadsColumna(etapa._id)}
                                </span>
                              </span>
                            </Title>
                          </div>

                          <div
                            style={{ flex: 1, backgroundColor: "#e6e6e636" }}
                          >
                            <DroppableColumn
                              id={etapa._id}
                              statusColor={etapa.color}
                            >
                              {this.getCardsForColumn(etapa)}
                            </DroppableColumn>
                          </div>

                          <div
                            style={{
                              backgroundColor: "#ffffff",
                              padding: "8px 15px",
                              borderRadius: "0 0 6px 6px",
                              border: "1px solid #f0f0f0",
                              borderTop: "none",
                              textAlign: "right",
                            }}
                          >
                            <Text
                              type="secondary"
                              style={{
                                fontSize: "10px",
                                display: "block",
                                textTransform: "uppercase",
                              }}
                            >
                              Total Valor
                            </Text>
                            <Text
                              strong
                              style={{ color: "#52c41a", fontSize: "13px" }}
                            >
                              $
                              {totalCaja.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                            </Text>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Zona de drops */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                  marginBottom: "10px",
                  height: this.state.activeId ? "80px" : "0px",
                  overflow: "hidden",
                  transition: "height 0.3s ease",
                }}
              >
                <DroppableZone
                  id="zona_perdido"
                  color="#ff4d4f"
                  icono={<CloseCircleOutlined />}
                  texto="PERDIDO"
                  activo={!!this.state.activeId}
                />
                <DroppableZone
                  id="zona_ganado"
                  color="#52c41a"
                  icono={<TrophyOutlined />}
                  texto="GANADO"
                  activo={!!this.state.activeId}
                />
              </div>
            </div>
          )}

          {/* Tabla */}
          {this.state.vistaTabla && (
            <div style={{ position: "relative" }}>
              {this.renderLoadingOverlay(this.state.loadingTabla)}
              <TableItemDinamico
              ref={(ref) => {
                this.tableRef = ref;
              }}
              onRef={(ref) => {
                this.tableRef = ref;
              }}
              totalRecords={this.state.totalLeadsTabla}
              onFetchData={this.consultarLeadsTabla.bind(this)}
              loading={this.state.loadingTabla}
              dataSource={this.state.leadsTabla}
              columns={columnsTabla}
              size="small"
            />
            </div>
          )}

          {createPortal(
            <DragOverlay dropAnimation={null}>
              {activeId ? (
                <div
                  style={{
                    width: "260px",
                    transform: "rotate(3deg)",
                    cursor: "grabbing",
                    zIndex: 10000,
                  }}
                >
                  <DraggableCard
                    id={activeId}
                    lead={activeLead}
                    isDragDisabled={false}
                    colorEtapa={etapaDelLeadActivo?.color || "#ccc"}
                    probabilidad={etapaDelLeadActivo?.probabilidadExito || 0}
                    mostrarDetalles={this.state.mostrarDetalles}
                    avisoActivo={activeLead.avisoActivo ?? null}
                  />
                </div>
              ) : null}
            </DragOverlay>,
            document.body,
          )}
        </DndContext>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAccesoConfiguracionCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69e9994e200bae6f82429037",
      )?.activado,
    permisoMasterCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a170cabe0d8ec48005e197f",
      )?.activado,
    tieneWhatsapp: !!state.empresa.whatsapp,
  };
};

export default connect(mapStateToProps)(CRMDashboard);
